module.exports = __webpack_public_path__ + "static/logo-f95d281324d2ad62c8b4a031c81d43a7.png";